const ADD = state => {
	state.requestLoading++
}

const REM = state => {
	state.requestLoading--
}

const TOGGLE_THEME = (state, payload) => {
	state.theme = payload
}

const TOGGLE_SHOW_SIDEBAR = (state, payload) => {
	state.showSidebar = payload
}

const UPDATE_MODULES = (state, payload) => {
	state.modules = payload ? [...payload] : []
}

const UPDATE_MODALITIES = (state, payload) => {
	state.modalities = payload ? [...payload] : []
}

const UPDATE_DICOM_MODALITIES = (state, payload) => {
	state.dicom_modalities = payload ? [...payload] : []
}

const UPDATE_SCHEDULES = (state, payload) => {
	state.schedules = payload ? [...payload] : []
}

const UPDATE_ICON_SIZE = (state, payload) => {
	state.icon_size = payload
}

const UPDATE_CAROUSEL_ORIENTATION = (state, payload) => {
	state.carousel_orientation = payload
}

const UPDATE_MENU_ORDER = (state, payload) => {
	state.menu_order = payload
}

const UPDATE_LAST_MODALITY_ID = (state, payload) => {
	state.last_modality_id = payload
}

const UPDATE_KEEP_CONNECTED = (state, payload) => {
	state.keep_connected = payload
}

const UPDATE_FAVORITE_ROUTE_NAME = (state, payload) => {
	state.favoriteRouteName = payload
}

const UPDATE_SELECTED_RECEPTION_COUNTER = (state, payload) => {
	state.selectedReceptionCounter = payload
}

const TOGGLE_TOOLBAR = (state, payload) => {
	state.toolBar = payload
}

const TOGGLE_INFOBAR = (state, payload) => {
	state.infoBar = payload
}
const TOGGLE_SUBTITLE = (state, payload) => {
	state.subtitle = payload
}

export {
	ADD,
	REM,
	TOGGLE_THEME,
	TOGGLE_SHOW_SIDEBAR,
	UPDATE_MODULES,
	UPDATE_MODALITIES,
	UPDATE_DICOM_MODALITIES,
	UPDATE_SCHEDULES,
	UPDATE_ICON_SIZE,
	UPDATE_CAROUSEL_ORIENTATION,
	UPDATE_MENU_ORDER,
	UPDATE_LAST_MODALITY_ID,
	UPDATE_KEEP_CONNECTED,
	UPDATE_FAVORITE_ROUTE_NAME,
	UPDATE_SELECTED_RECEPTION_COUNTER,
	TOGGLE_TOOLBAR,
	TOGGLE_INFOBAR,
	TOGGLE_SUBTITLE
}
